import Swiper from 'swiper';
import { Navigation, Thumbs, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import 'swiper/css/pagination';

const InitSwiper = () => {
  const swiperGalleries = document.querySelectorAll('[data-component="swiper-gallery"]');
  const swiperGalleryThumbs = document.querySelectorAll('[data-component="swiper-gallery-thumbs"]');

  // if (!swiperGalleries.length || !swiperGalleryThumbs.length) return;

  if (swiperGalleries.length > 0) {
    // 썸네일 swiper 인스턴스 생성
    const thumbsInstances = [];
    swiperGalleryThumbs.forEach((thumbEl) => {
      const thumbSwiper = new Swiper(thumbEl, {
        modules: [Thumbs],
        spaceBetween: 10,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true,
      });
      thumbsInstances.push(thumbSwiper);
    });

    // 메인 swiper 인스턴스 생성
    swiperGalleries.forEach((galleryEl, index) => {
      new Swiper(galleryEl, {
        modules: [Navigation, Thumbs],
        thumbs: {
          swiper: thumbsInstances[index], // 같은 인덱스의 썸네일 swiper 연결
        },
        navigation: {
          nextEl: galleryEl.querySelector('.swiper-button-next'),
          prevEl: galleryEl.querySelector('.swiper-button-prev'),
        },
      });
    });
  }

  const swiperHero = document.querySelector('[data-component="swiper--hero"]');
  if (swiperHero) {
    new Swiper(swiperHero, {
      modules: [Navigation, Pagination],
      navigation: {
        nextEl: swiperHero.querySelector('.swiper-button-next'),
        prevEl: swiperHero.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: swiperHero.querySelector('.swiper-pagination'),
        clickable: true,
      },
      loop: true,
    });
  }
};

export default InitSwiper;
